import React, { useEffect, useState, useRef, createElement } from 'react';
import { Ticket, X, User, Mail, Phone, Globe, AlertTriangle, Brain, Rocket, CheckCircle, Clock, Target, Users, Shield, ArrowRight } from 'lucide-react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
const COUNTRY_CODES = [{
  code: '+1',
  country: 'USA/Canada'
}, {
  code: '+52',
  country: 'México'
}, {
  code: '+57',
  country: 'Colombia'
}, {
  code: '+34',
  country: 'España'
}, {
  code: '+39',
  country: 'Italia'
}, {
  code: '+54',
  country: 'Argentina'
}, {
  code: '+56',
  country: 'Chile'
}, {
  code: '+51',
  country: 'Perú'
}, {
  code: '+593',
  country: 'Ecuador'
}, {
  code: '+58',
  country: 'Venezuela'
}, {
  code: '+502',
  country: 'Guatemala'
}, {
  code: '+503',
  country: 'El Salvador'
}, {
  code: '+504',
  country: 'Honduras'
}, {
  code: '+505',
  country: 'Nicaragua'
}, {
  code: '+506',
  country: 'Costa Rica'
}, {
  code: '+507',
  country: 'Panamá'
}, {
  code: '+591',
  country: 'Bolivia'
}, {
  code: '+595',
  country: 'Paraguay'
}, {
  code: '+598',
  country: 'Uruguay'
}, {
  code: '+1-809',
  country: 'Rep. Dominicana'
}];
export function WebinarJuevesNewPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [areaCode, setAreaCode] = useState('+1');
  const [phone, setPhone] = useState('');
  const [smsConsent, setSmsConsent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [fbclid, setFbclid] = useState('');
  const [ipAddress, setIpAddress] = useState('');
  const [fbp, setFbp] = useState('');
  const [fbc, setFbc] = useState('');
  const [utmParams, setUtmParams] = useState<Record<string, string>>({});
  const [userAgent, setUserAgent] = useState('');
  const [pageReferrer, setPageReferrer] = useState('');
  const [landingPageUrl, setLandingPageUrl] = useState('');
  const nameInputRef = useRef<HTMLInputElement>(null);
  const emailInputRef = useRef<HTMLInputElement>(null);
  const phoneInputRef = useRef<HTMLInputElement>(null);
  const areaCodeRef = useRef<HTMLSelectElement>(null);
  const navigate = useNavigate();
  const location = useLocation();
  // Function to get next Thursday date with formatted month
  const getNextThursday = () => {
    const now = new Date();
    const estTime = new Date(now.toLocaleString('en-US', {
      timeZone: 'America/New_York'
    }));
    const currentDay = estTime.getDay(); // 0 = Sunday, 4 = Thursday
    const currentHour = estTime.getHours();
    let daysUntilThursday = 0;
    if (currentDay === 4) {
      if (currentHour >= 19) {
        daysUntilThursday = 7;
      } else {
        daysUntilThursday = 0;
      }
    } else if (currentDay < 4) {
      daysUntilThursday = 4 - currentDay;
    } else {
      daysUntilThursday = 7 - currentDay + 4;
    }
    const nextThursday = new Date(estTime);
    nextThursday.setDate(estTime.getDate() + daysUntilThursday);
    const day = nextThursday.getDate();
    const month = nextThursday.toLocaleString('es-ES', {
      month: 'long'
    }).toUpperCase();
    return `${month} ${day}`;
  };
  useEffect(() => {
    // === FULL TRACKING SUITE ===
    setLandingPageUrl(window.location.href);
    setPageReferrer(document.referrer || '');
    setUserAgent(navigator.userAgent || '');
    const urlParams = new URLSearchParams(window.location.search);
    const fbclidParam = urlParams.get('fbclid');
    if (fbclidParam) {
      setFbclid(fbclidParam);
      const fbcCookie = document.cookie.split('; ').find(row => row.startsWith('_fbc='))?.split('=')[1];
      setFbc(fbcCookie || `fb.1.${Date.now()}.${fbclidParam}`);
    } else {
      const fbcCookie = document.cookie.split('; ').find(row => row.startsWith('_fbc='))?.split('=')[1];
      if (fbcCookie) setFbc(fbcCookie);
    }
    const utms: Record<string, string> = {};
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];
    utmKeys.forEach(key => {
      const val = urlParams.get(key);
      if (val) utms[key] = val;
    });
    const adParams = ['gclid', 'gbraid', 'wbraid', 'ttclid', 'ScCid', 'msclkid'];
    adParams.forEach(key => {
      const val = urlParams.get(key);
      if (val) utms[key] = val;
    });
    setUtmParams(utms);
    const readFbpCookie = () => {
      const fbpCookie = document.cookie.split('; ').find(row => row.startsWith('_fbp='))?.split('=')[1];
      if (fbpCookie) {
        setFbp(fbpCookie);
      }
    };
    readFbpCookie();
    const fbpTimer = setTimeout(readFbpCookie, 2000);
    fetch('https://api.ipify.org?format=json').then(res => res.json()).then(data => {
      if (data.ip) {
        setIpAddress(data.ip);
      }
    }).catch(err => console.warn('Could not fetch IP address:', err));
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    return () => clearTimeout(fbpTimer);
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) return;
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);
    const domName = nameInputRef.current?.value?.trim() || '';
    const domEmail = emailInputRef.current?.value?.trim() || '';
    const domPhone = phoneInputRef.current?.value?.replace(/\D/g, '').trim() || '';
    const domAreaCode = areaCodeRef.current?.value || '+1';
    const finalName = domName || name.trim() || (formData.get('name') as string)?.trim() || '';
    const finalEmail = domEmail || email.trim() || (formData.get('email') as string)?.trim() || '';
    const finalPhone = domPhone || phone.trim() || (formData.get('phone') as string)?.replace(/\D/g, '').trim() || '';
    const finalAreaCode = domAreaCode || areaCode || formData.get('areaCode') as string || '+1';
    if (!finalName || finalName.length < 2) {
      alert('Por favor ingresa tu nombre completo');
      return;
    }
    if (!finalEmail || !finalEmail.includes('@')) {
      alert('Por favor ingresa un email válido');
      return;
    }
    if (!finalPhone || finalPhone.length < 7) {
      alert('Por favor ingresa tu número de teléfono');
      return;
    }
    if (!smsConsent) {
      alert('Por favor marca la casilla de consentimiento de SMS para continuar.');
      return;
    }
    setIsSubmitting(true);
    try {
      const webhookUrl = 'https://services.leadconnectorhq.com/hooks/HMYR0XQcpZnIeoWD2nrn/webhook-trigger/PLACEHOLDER_WEBINAR_JUEVES_NEW';
      const payload = {
        name: finalName,
        email: finalEmail,
        phone: `${finalAreaCode}${finalPhone}`,
        first_name: finalName.split(' ')[0],
        last_name: finalName.split(' ').slice(1).join(' ') || finalName.split(' ')[0],
        full_name: finalName,
        phoneNumber: finalPhone,
        phone_number: finalPhone,
        fullPhone: `${finalAreaCode}${finalPhone}`,
        full_phone: `${finalAreaCode}${finalPhone}`,
        areaCode: finalAreaCode,
        area_code: finalAreaCode,
        contact_name: finalName,
        contactName: finalName,
        source: location.pathname,
        page_path: location.pathname,
        fbclid: fbclid || '',
        fbc: fbc || '',
        fbp: fbp || '',
        ip_address: ipAddress || '',
        ipAddress: ipAddress || '',
        user_agent: userAgent || '',
        userAgent: userAgent || '',
        utm_source: utmParams.utm_source || '',
        utm_medium: utmParams.utm_medium || '',
        utm_campaign: utmParams.utm_campaign || '',
        utm_content: utmParams.utm_content || '',
        utm_term: utmParams.utm_term || '',
        utm_id: utmParams.utm_id || '',
        gclid: utmParams.gclid || '',
        gbraid: utmParams.gbraid || '',
        wbraid: utmParams.wbraid || '',
        ttclid: utmParams.ttclid || '',
        msclkid: utmParams.msclkid || '',
        event_time: Math.floor(Date.now() / 1000),
        event_source_url: landingPageUrl || window.location.href,
        action_source: 'website',
        page_referrer: pageReferrer || '',
        landing_page: landingPageUrl || window.location.href
      };
      await fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      navigate('/thank-you');
    } catch (error) {
      console.error('Error submitting form:', error);
      navigate('/thank-you');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="min-h-screen bg-black text-white font-sans overflow-x-hidden selection:bg-[#00f7fc]/30 selection:text-[#00f7fc]" data-id="element-5682" data-mp="img8jd0npvp9">
      <noscript data-id="element-5683" data-mp="dqiq915u2f9u">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-5684" data-mp="ro7ac6s2tidu" />
      </noscript>

      {/* Background Image Layer */}
      <div className="absolute top-0 left-0 w-full h-[600px] md:h-[800px] z-0 opacity-40" data-id="element-5685" data-mp="2tfakkuy20uxv">
        <img src="https://cdn.magicpatterns.com/uploads/owSR6X5Pw8KuRfkif7sGzk/6936d7f7169a421d1ba8a294.png" alt="Background Pattern" className="w-full h-full object-cover" style={{
        maskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
        WebkitMaskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)'
      }} data-id="element-5686" data-mp="2pe8kyd086gvd" />
      </div>

      <main className="relative z-10 w-full" data-id="element-5687" data-mp="1xdl6vl846lkr">
        {/* SECTION 1: ABOVE THE FOLD */}
        <section className="pt-8 md:pt-16 pb-16 md:pb-24 px-4 flex flex-col items-center text-center max-w-5xl mx-auto" data-id="element-5688" data-mp="1sft6s3xbft5h">
          <div className="w-full max-w-[320px] md:max-w-[500px] lg:max-w-[600px] mb-6 animate-fade-in-up" data-id="element-5689" data-mp="2q43bwrseex0t">
            <img src="https://cdn.magicpatterns.com/uploads/rZjvDAnMDLXJQX7she8uyT/Banner_48h_Cash_Machine_2.png" alt="48H AI Cash Machine" className="w-full h-auto drop-shadow-2xl" data-id="element-5690" data-mp="2l59vorlq8rwy" />
          </div>

          <div className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 rounded-full px-4 py-2 mb-6" data-id="element-5691" data-mp="2bb9q6omj9knp">
            <span className="relative flex h-3 w-3" data-id="element-5692" data-mp="341i2hzue1aud">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#00f7fc] opacity-75" data-id="element-5693" data-mp="33zovukjryqmd"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-[#00f7fc]" data-id="element-5694" data-mp="3gbr8ex83pple"></span>
            </span>
            <span className="text-sm font-bold text-[#00f7fc] uppercase tracking-wide" data-id="element-5695" data-mp="3lakomxervup9">
              Masterclass Gratuita
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black uppercase leading-tight md:leading-tight mb-6" data-id="element-5696" data-mp="3q83zrog6brcz">
            El Sistema de IA para Lanzar un Producto Digital Rentable en{' '}
            <span className="text-[#00f7fc]" data-id="element-5697" data-mp="33o355oe5k3n">48 Horas</span>
          </h1>

          <p className="text-lg md:text-2xl text-gray-300 mb-10 max-w-4xl leading-relaxed" data-id="element-5698" data-mp="7xiki2gixmzk">
            Descubre cómo dejar de improvisar y usar un sistema que elige el
            producto, crea la oferta y construye la máquina de ventas por ti.
            Incluso si empiezas desde cero, sin experiencia y sin seguidores.
          </p>

          <div className="w-full max-w-2xl mb-8" data-id="element-5699" data-mp="ltmafjkd7968">
            <button onClick={() => setShowRegisterModal(true)} className="group relative w-full bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] text-black rounded-full py-4 px-6 md:py-6 md:px-10 shadow-[0_0_40px_rgba(253,185,49,0.4)] transition-all duration-300 transform hover:scale-[1.02]" data-id="element-5700" data-mp="2ixo39khwxw7j">
              <div className="flex flex-col items-center justify-center" data-id="element-5701" data-mp="2mw3opjyciwiu">
                <div className="flex items-center gap-3 mb-1" data-id="element-5702" data-mp="31lt2cenmkt00">
                  <Ticket className="w-8 h-8 md:w-10 md:h-10 text-black fill-black/10" data-id="element-5703" data-mp="2woj72idk1n49" />
                  <span className="text-xl md:text-3xl font-black uppercase tracking-tight" data-id="element-5704" data-mp="3anivpq12i20f">
                    Sí, ¡Quiero Reservar Mi Lugar Gratis!
                  </span>
                </div>
              </div>
              <div className="absolute inset-0 rounded-full overflow-hidden pointer-events-none" data-id="element-5705" data-mp="1g9897o7y3jxt">
                <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-[#00D9FF]/60 to-transparent skew-x-[-25deg] group-hover:animate-shine" data-id="element-5706" data-mp="1c8ocumv74kcq" />
              </div>
            </button>
          </div>

          <div className="flex flex-col items-center gap-4 text-gray-400" data-id="element-5707" data-mp="165b6zzd32528">
            <div className="flex items-center gap-2 text-lg font-medium" data-id="element-5708" data-mp="sddaco0k61my">
              <Clock className="w-5 h-5 text-[#00f7fc]" data-id="element-5709" data-mp="xczkgol3b1rj" />
              <span data-id="element-5710" data-mp="xbepwyyrzito">
                El próximo workshop en vivo comienza el:{' '}
                <strong className="text-white" data-id="element-5711" data-mp="iep4enlulczm">
                  {getNextThursday()} | 7PM EST
                </strong>
              </span>
            </div>
            <div className="flex items-center gap-2 text-sm" data-id="element-5712" data-mp="9g3m8tkafzzd">
              <Users className="w-4 h-4 text-[#FDB931]" data-id="element-5713" data-mp="9hn1qhy4e703" />
              <span data-id="element-5714" data-mp="efopvhaekwif">
                Únete a más de <strong data-id="element-5715" data-mp="egretjo60ovp">10,000+</strong> emprendedores que ya
                descubrieron el sistema HEYLLOYD.
              </span>
            </div>
          </div>
        </section>

        {/* SECTION 2: EL PROBLEMA */}
        <section className="py-16 md:py-24 px-4 bg-gray-900/50 border-y border-gray-800" data-id="element-5716" data-mp="8qev3lnxrm68">
          <div className="max-w-4xl mx-auto" data-id="element-5717" data-mp="8o2fvg9kbpwv">
            <div className="text-center mb-12" data-id="element-5718" data-mp="3sdgpe1ggb13">
              <AlertTriangle className="w-12 h-12 text-[#FDB931] mx-auto mb-6" data-id="element-5719" data-mp="3pix1oq9mu8q" />
              <h2 className="text-3xl md:text-4xl font-black mb-6 leading-tight" data-id="element-5720" data-mp="3uvtt16gf54t7">
                Si Estás Cansado de Probarlo Todo Sin Resultados Sostenibles,{' '}
                <span className="text-[#FDB931]" data-id="element-5721" data-mp="3ly05ajwpzjhn">No Estás Solo.</span>
              </h2>
              <p className="text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-5722" data-mp="3h5yl8btb8oh2">
                Has visto los videos, comprado los cursos y quizás hasta lanzado
                anuncios. Dropshipping, Amazon FBA, marketing de afiliados... la
                lista sigue. Pero la realidad es que sigues atrapado en el mismo
                lugar: trabajando demasiado por muy pocos resultados, abrumado
                por la cantidad de decisiones que tienes que tomar y sin un
                ingreso predecible que te dé la libertad que buscas. El problema
                no es tu esfuerzo. Es que estás jugando un juego sin tener las
                reglas claras.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5723" data-mp="1mr2z03fcvxe6">
              <div className="bg-black/50 border border-gray-800 p-6 rounded-2xl flex items-start gap-4" data-id="element-5724" data-mp="1roupqu49ldgs">
                <div className="bg-red-500/10 p-3 rounded-xl shrink-0" data-id="element-5725" data-mp="uz3swo8i3e7t">
                  <Brain className="w-6 h-6 text-red-500" data-id="element-5726" data-mp="ux0v3i13wgsj" />
                </div>
                <div data-id="element-5727" data-mp="z0p2o0pqncds">
                  <h3 className="font-bold text-lg mb-2 text-white" data-id="element-5728" data-mp="yy30kglm9p2y">
                    ¿Paralizado por el análisis?
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-5729" data-mp="18rac6j6ya1bh">
                    Tantas opciones de nicho y producto que al final no eliges
                    ninguna.
                  </p>
                </div>
              </div>

              <div className="bg-black/50 border border-gray-800 p-6 rounded-2xl flex items-start gap-4" data-id="element-5730" data-mp="g7uxfyhx2ymr">
                <div className="bg-red-500/10 p-3 rounded-xl shrink-0" data-id="element-5731" data-mp="1jiij4b6lkvdc">
                  <Target className="w-6 h-6 text-red-500" data-id="element-5732" data-mp="1el8w126okvso" />
                </div>
                <div data-id="element-5733" data-mp="1sc41e4hz0uri">
                  <h3 className="font-bold text-lg mb-2 text-white" data-id="element-5734" data-mp="1scdptnndatv3">
                    ¿Cansado de crear contenido?
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-5735" data-mp="10lppgdtipsih">
                    Sientes que eres un esclavo del algoritmo de Instagram o
                    TikTok sin ver un retorno claro.
                  </p>
                </div>
              </div>

              <div className="bg-black/50 border border-gray-800 p-6 rounded-2xl flex items-start gap-4" data-id="element-5736" data-mp="19kkwfs4dz6mu">
                <div className="bg-red-500/10 p-3 rounded-xl shrink-0" data-id="element-5737" data-mp="14pp1ok7rm561">
                  <Globe className="w-6 h-6 text-red-500" data-id="element-5738" data-mp="2l09j0idqa3n4" />
                </div>
                <div data-id="element-5739" data-mp="2g1pymmes8zwv">
                  <h3 className="font-bold text-lg mb-2 text-white" data-id="element-5740" data-mp="2g285ecz2mwj1">
                    ¿Frustrado con la tecnología?
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-5741" data-mp="2sl3po8zxnzdq">
                    Las plataformas, los embudos y las automatizaciones se
                    sienten como un laberinto imposible.
                  </p>
                </div>
              </div>

              <div className="bg-black/50 border border-gray-800 p-6 rounded-2xl flex items-start gap-4" data-id="element-5742" data-mp="2jmrpbf99ln83">
                <div className="bg-red-500/10 p-3 rounded-xl shrink-0" data-id="element-5743" data-mp="37cciss31o2vm">
                  <Rocket className="w-6 h-6 text-red-500" data-id="element-5744" data-mp="3c8ta1v5jixcx" />
                </div>
                <div data-id="element-5745" data-mp="2xjf0on1ysfxj">
                  <h3 className="font-bold text-lg mb-2 text-white" data-id="element-5746" data-mp="2xjx17vvntgb9">
                    ¿Quemando dinero en anuncios?
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-5747" data-mp="3q9dtmtja4x7h">
                    Inviertes sin una estrategia clara, esperando un golpe de
                    suerte que nunca llega.
                  </p>
                </div>
              </div>

              <div className="bg-black/50 border border-gray-800 p-6 rounded-2xl flex items-start gap-4 md:col-span-2" data-id="element-5748" data-mp="1uyvyij651byu">
                <div className="bg-red-500/10 p-3 rounded-xl shrink-0" data-id="element-5749" data-mp="1q51ipqtnlh51">
                  <User className="w-6 h-6 text-red-500" data-id="element-5750" data-mp="1l8b0oxyagbgz" />
                </div>
                <div data-id="element-5751" data-mp="1h77n6i3pqrix">
                  <h3 className="font-bold text-lg mb-2 text-white" data-id="element-5752" data-mp="1h80xtu5sm16c">
                    ¿Sientes que empezaste tarde?
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-5753" data-mp="28xlx638lvjpb">
                    Crees que no tener experiencia o miles de seguidores es una
                    desventaja insuperable.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 3: LA SOLUCIÓN */}
        <section className="py-16 md:py-24 px-4 relative overflow-hidden" data-id="element-5754" data-mp="ti6nbj8y4op9">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#00f7fc]/10 blur-[120px] rounded-full pointer-events-none" data-id="element-5755" data-mp="oh92eywjxgk2"></div>

          <div className="max-w-4xl mx-auto relative z-10" data-id="element-5756" data-mp="353p7wvfvxieg">
            <div className="text-center mb-16" data-id="element-5757" data-mp="354763xm3y6p0">
              <h2 className="text-3xl md:text-5xl font-black mb-6 leading-tight" data-id="element-5758" data-mp="3950u0qzjvlhw">
                La Nueva Forma de Construir un Negocio Digital:{' '}
                <span className="text-[#00f7fc]" data-id="element-5759" data-mp="3dydecox7564u">
                  Deja que un Sistema de IA Decida Por Ti
                </span>
              </h2>
              <p className="text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-5760" data-mp="3ntnhjfzbzjk7">
                Imagina por un segundo si pudieras eliminar el 90% de las
                decisiones que te frenan. ¿Y si un sistema pudiera analizar el
                mercado por ti, decirte exactamente qué producto vender, crear
                ese producto, escribir el copy de ventas y hasta generar los
                anuncios? Eso ya no es el futuro. Es HEYLLOYD, el primer sistema
                operativo de decisiones para emprendedores digitales. En esta
                Masterclass, te mostraremos en vivo cómo funciona.
              </p>
            </div>

            <div className="space-y-6" data-id="element-5761" data-mp="1r7ds29zfh2pt">
              {[{
              title: 'Claridad Absoluta',
              desc: 'Descubre productos de alta demanda que el mercado ya quiere comprar, eliminando las adivinanzas.'
            }, {
              title: 'Velocidad de Implementación',
              desc: 'Lanza un producto digital completo (ebook, curso, etc.) en menos de 48 horas, no en meses.'
            }, {
              title: 'Conversión sin Esfuerzo',
              desc: 'Genera páginas de venta y cartas de venta persuasivas con IA, aunque no sepas nada de copywriting.'
            }, {
              title: 'Marketing Automatizado',
              desc: 'Crea los guiones, imágenes y copys para tus anuncios con un clic, listos para lanzar y validar.'
            }, {
              title: 'La Ventaja del Novato',
              desc: 'Aprende por qué empezar desde cero es tu mayor fortaleza cuando tienes un sistema probado que seguir.'
            }].map((item, i) => <div key={i} className="bg-gray-900/80 border border-[#00f7fc]/20 p-6 rounded-2xl flex items-center gap-6 hover:border-[#00f7fc]/50 transition-colors" data-id="element-5762" data-mp="d93mc9xzijtn" data-mpi={i}>
                  <div className="bg-[#00f7fc]/10 p-4 rounded-full shrink-0" data-id="element-5763" data-mp="3c7hce7aoftu">
                    <CheckCircle className="w-8 h-8 text-[#00f7fc]" data-id="element-5764" data-mp="10zg38ab7jqwd" />
                  </div>
                  <div data-id="element-5765" data-mp="w0d579tnakxw">
                    <h3 className="text-xl font-bold text-white mb-2" data-id="element-5766" data-mp="vztjrj4sdef4">
                      {item.title}
                    </h3>
                    <p className="text-gray-400 leading-relaxed" data-id="element-5767" data-mp="qzp4fwfm6pqh">{item.desc}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* SECTION 4: ¿QUÉ APRENDERÁS? */}
        <section className="py-16 md:py-24 px-4 bg-gray-900/50 border-y border-gray-800" data-id="element-5768" data-mp="3bssix9xlk6mx">
          <div className="max-w-4xl mx-auto" data-id="element-5769" data-mp="36r37vuadjsyu">
            <h2 className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-5770" data-mp="1yt8nzrczetwo">
              Esto es lo que Descubrirás en la{' '}
              <span className="text-[#FDB931]" data-id="element-5771" data-mp="22t9bs2lz0hge">AI Masterclass en Vivo:</span>
            </h2>

            <div className="bg-black border border-gray-800 rounded-2xl overflow-hidden mb-12" data-id="element-5772" data-mp="1otq5zggmti79">
              <div className="grid grid-cols-1 md:grid-cols-3 bg-gray-800/50 border-b border-gray-800 p-4" data-id="element-5773" data-mp="1tstb10wm3of8">
                <div className="font-bold text-gray-400 uppercase tracking-wide text-sm md:col-span-1" data-id="element-5774" data-mp="1f46ks45g5c98">
                  Módulo
                </div>
                <div className="font-bold text-gray-400 uppercase tracking-wide text-sm md:col-span-2 hidden md:block" data-id="element-5775" data-mp="164a4apt7njp9">
                  Contenido
                </div>
              </div>

              <div className="divide-y divide-gray-800" data-id="element-5776" data-mp="1b10jlax6yb9m">
                {[{
                mod: 'El Framework HEYLLOYD',
                desc: 'El sistema paso a paso que usan nuestros estudiantes para pasar de cero a ventas en tiempo récord.'
              }, {
                mod: 'DEMO EN VIVO',
                desc: 'Verás con tus propios ojos cómo creamos y lanzamos un producto desde cero usando IA en menos de 30 minutos.'
              }, {
                mod: 'El Secreto de la Validación Rápida',
                desc: 'Cómo usar micro-presupuestos en anuncios ($10/día) para validar tu oferta y obtener tus primeras ventas.'
              }, {
                mod: 'El Fin de la Improvisación',
                desc: 'Cómo tomar decisiones basadas en datos, no en emociones, para escalar de forma predecible.'
              }, {
                mod: 'Sesión de Q&A',
                desc: 'Al final, responderé todas tus preguntas para que salgas con una claridad total sobre tus siguientes pasos.'
              }].map((row, i) => <div key={i} className="grid grid-cols-1 md:grid-cols-3 p-6 gap-4 items-center hover:bg-gray-900/50 transition-colors" data-id="element-5777" data-mp="1k5gyrkx58kby" data-mpi={i}>
                    <div className="font-bold text-lg text-[#00f7fc] md:col-span-1" data-id="element-5778" data-mp="1f90besxrq9zx">
                      {row.mod}
                    </div>
                    <div className="text-gray-300 md:col-span-2 leading-relaxed" data-id="element-5779" data-mp="3dopni08q6pyc">
                      {row.desc}
                    </div>
                  </div>)}
              </div>
            </div>

            <div className="text-center" data-id="element-5780" data-mp="3neiusp1u4iws">
              <button onClick={() => setShowRegisterModal(true)} className="inline-flex items-center gap-3 bg-gradient-to-r from-[#00f7fc] to-[#00d7dc] hover:from-[#00d7dc] hover:to-[#00b8bc] text-black font-black uppercase tracking-wide rounded-full py-4 px-10 shadow-[0_0_30px_rgba(0,247,252,0.3)] transition-all duration-300 transform hover:scale-[1.02]" data-id="element-5781" data-mp="3ne975849inu9">
                <span data-id="element-5782" data-mp="34ou6hesho0qe">¡Reserva Mi Lugar Ahora!</span>
                <ArrowRight className="w-5 h-5" data-id="element-5783" data-mp="34pm40v5nc8jb" />
              </button>
            </div>
          </div>
        </section>

        {/* SECTION 5: SOBRE EL PRESENTADOR */}
        <section className="py-16 md:py-24 px-4" data-id="element-5784" data-mp="jx0nqjtvzfxf">
          <div className="max-w-5xl mx-auto" data-id="element-5785" data-mp="24g4jvv4xorpp">
            <div className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-10" data-id="element-5786" data-mp="24f2yoxu7eou9">
              <div className="w-full md:w-1/3 shrink-0" data-id="element-5787" data-mp="1uq1ip7nns7ga">
                <div className="relative" data-id="element-5788" data-mp="1uogndftiskhd">
                  <div className="absolute -inset-4 bg-gradient-to-br from-[#00f7fc] to-[#FDB931] rounded-full blur-2xl opacity-20" data-id="element-5789" data-mp="1prhwr792evnx"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/qGszUSvXKGkMXKzhkKHKP9/heylloyd-image-1769473134106.png" alt="Gabriel Beltrán" className="relative w-64 h-64 md:w-full md:h-auto aspect-square object-cover rounded-full border-4 border-gray-800 mx-auto" data-id="element-5790" data-mp="1kswruuivbnt5" />
                </div>
              </div>

              <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-5791" data-mp="16u6v5fzynq5b">
                <div className="inline-flex items-center gap-2 bg-gray-800 rounded-full px-4 py-1.5 mb-4" data-id="element-5792" data-mp="364f2a0bdq0qi">
                  <Shield className="w-4 h-4 text-[#FDB931]" data-id="element-5793" data-mp="317okn8jxex2z" />
                  <span className="text-xs font-bold text-gray-300 uppercase tracking-wider" data-id="element-5794" data-mp="zhhbo5t3muhb">
                    Tu Instructor
                  </span>
                </div>
                <h2 className="text-3xl md:text-4xl font-black mb-6" data-id="element-5795" data-mp="149r1llu7rujl">
                  Presentado por:{' '}
                  <span className="text-[#00f7fc]" data-id="element-5796" data-mp="ui4i727q2p5r">Gabriel Beltrán</span>
                </h2>
                <p className="text-gray-300 text-lg leading-relaxed mb-8" data-id="element-5797" data-mp="ufs4j18zz0yi">
                  Después de pasar de vivir de cheque en cheque a generar más de
                  $50 millones de dólares en línea, Gabriel descubrió que el
                  secreto del éxito no era trabajar más duro, sino construir
                  sistemas que tomaran mejores decisiones. Su obsesión se
                  convirtió en crear un sistema que permitiera a cualquier
                  persona, sin importar su experiencia, lanzar un negocio
                  digital rentable. Así nació HEYLLOYD. Hoy, su misión es ayudar
                  a miles de emprendedores a alcanzar la libertad financiera y
                  de tiempo a través de la inteligencia artificial y los
                  productos digitales.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 6: CTA FINAL */}
        <section className="py-16 md:py-24 px-4 bg-gradient-to-b from-transparent to-[#00f7fc]/5" data-id="element-5798" data-mp="2l01lw6h2w1qp">
          <div className="max-w-3xl mx-auto text-center" data-id="element-5799" data-mp="1x9xj21bps60r">
            <h2 className="text-3xl md:text-5xl font-black mb-6 leading-tight" data-id="element-5800" data-mp="1x8co4alhml2d">
              Tu Negocio Digital Está a un Sistema de Distancia.{' '}
              <span className="text-[#FDB931]" data-id="element-5801" data-mp="2642fd09ma9no">¿Vas a Seguir Esperando?</span>
            </h2>
            <p className="text-xl text-gray-300 mb-10 leading-relaxed" data-id="element-5802" data-mp="21c2d3162r4nx">
              Esta Masterclass es 100% gratuita, pero los cupos son limitados
              para poder interactuar con los asistentes. Si estás realmente
              comprometido con cambiar tu situación y construir un negocio real,
              no dejes pasar esta oportunidad. El momento de actuar es ahora.
            </p>

            <button onClick={() => setShowRegisterModal(true)} className="group relative w-full md:w-auto bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] text-black rounded-full py-5 px-10 shadow-[0_0_40px_rgba(253,185,49,0.4)] transition-all duration-300 transform hover:scale-[1.02] mb-6" data-id="element-5803" data-mp="23g1mz2ozvnik">
              <div className="flex items-center justify-center gap-3" data-id="element-5804" data-mp="2hej7krjlsjw9">
                <Ticket className="w-6 h-6" data-id="element-5805" data-mp="2mcuht3dt8wf0" />
                <span className="text-xl md:text-2xl font-black uppercase tracking-tight" data-id="element-5806" data-mp="2mbjcgz4pvgls">
                  Sí, Quiero el Sistema. ¡Reservar Mi Lugar Gratis!
                </span>
              </div>
            </button>

            <div className="flex items-center justify-center gap-2 text-sm text-gray-500" data-id="element-5807" data-mp="305j36bllsryi">
              <Shield className="w-4 h-4" data-id="element-5808" data-mp="354dllcfnsei3" />
              <p data-id="element-5809" data-mp="3555euglsa057">
                Respetamos tu privacidad. Tu email está 100% seguro y solo lo
                usaremos para enviarte el acceso a la masterclass y
                recordatorios.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-5810" data-mp="359l9fihu2r26" />

      {/* Registration Modal */}
      {showRegisterModal && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={() => setShowRegisterModal(false)} data-id="element-5811" data-mp="318j5wpgvvsue">
          <div className="bg-gray-900 border border-gray-800 rounded-2xl max-w-md w-full p-6 md:p-8 relative shadow-[0_0_50px_rgba(253,185,49,0.15)]" onClick={e => e.stopPropagation()} data-id="element-5812" data-mp="1s335fhpls3v">
            <button onClick={() => setShowRegisterModal(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors p-1" data-id="element-5813" data-mp="3o7xiz5cnq2ya">
              <X className="w-6 h-6" data-id="element-5814" data-mp="kjvs8ytnqt6b" />
            </button>

            <div className="text-center mb-6" data-id="element-5815" data-mp="klgocsvmek6a">
              <h2 className="text-2xl md:text-3xl font-black text-white mb-2 uppercase" data-id="element-5816" data-mp="ftfgrk9edhml">
                Completa Tu Registro
              </h2>
              <p className="text-gray-400 text-sm" data-id="element-5817" data-mp="1hiu9ygsmljfy">
                Ingresa tus datos para asegurar tu cupo gratuito
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-5818" data-mp="1rfywihqdvgxa">
              {/* Name Input */}
              <div className="space-y-1" data-id="element-5819" data-mp="1mhf90cw55x2t">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-5820" data-mp="1mgckucq7e8ql">
                  Nombre Completo
                </label>
                <div className="relative" data-id="element-5821" data-mp="20ekdi8g7invy">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-5822" data-mp="1vgsktc7qmxqp">
                    <User className="h-5 w-5 text-gray-500" data-id="element-5823" data-mp="2a5exf65zdbe8" />
                  </div>
                  <input ref={nameInputRef} type="text" name="name" value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre" required minLength={2} autoComplete="name" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-[#FDB931] focus:bg-white/10 transition-all" data-id="element-5824" data-mp="257dfwpo7dk4v" />
                </div>
              </div>

              {/* Email Input */}
              <div className="space-y-1" data-id="element-5825" data-mp="32r3skzm5x3qa">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-5826" data-mp="2ou89eec75vwi">
                  Tu Mejor Email
                </label>
                <div className="relative" data-id="element-5827" data-mp="2tqoxx9nb6ca4">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-5828" data-mp="2f3vnoisnbwos">
                    <Mail className="h-5 w-5 text-gray-500" data-id="element-5829" data-mp="2juvpo2gmh4y5" />
                  </div>
                  <input ref={emailInputRef} type="email" name="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="ejemplo@correo.com" required autoComplete="email" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-[#FDB931] focus:bg-white/10 transition-all" data-id="element-5830" data-mp="2637bltmtc6ej" />
                </div>
              </div>

              {/* Phone Input Group */}
              <div className="space-y-1" data-id="element-5831" data-mp="6oxbe0w8d5vk">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-5832" data-mp="1x5uyj6sggj5">
                  WhatsApp / Teléfono
                </label>
                <div className="flex gap-2" data-id="element-5833" data-mp="3u182v5uu9tyn">
                  <div className="relative w-1/3" data-id="element-5834" data-mp="3p1lnoqvga3n7">
                    <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none" data-id="element-5835" data-mp="3p36kkn58lyo8">
                      <Globe className="h-4 w-4 text-gray-500" data-id="element-5836" data-mp="plp4f21kqzct" />
                    </div>
                    <select ref={areaCodeRef} name="areaCode" value={areaCode} onChange={e => setAreaCode(e.target.value)} className="w-full pl-8 pr-2 py-3 rounded-xl bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#FDB931] focus:bg-white/10 transition-all appearance-none text-sm" data-id="element-5837" data-mp="lleniuc8uoj6">
                      {COUNTRY_CODES.map(country => <option key={country.code} value={country.code} className="bg-gray-900" data-id="element-5838" data-mp="2wcy0uqv1z67j">
                          {country.code} {country.country}
                        </option>)}
                    </select>
                  </div>

                  <div className="relative w-2/3" data-id="element-5839" data-mp="2r95j1347z67g">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-5840" data-mp="2w7741tl7hflk">
                      <Phone className="h-5 w-5 text-gray-500" data-id="element-5841" data-mp="30xni9fwup58z" />
                    </div>
                    <input ref={phoneInputRef} type="tel" name="phone" value={phone} onChange={e => setPhone(e.target.value.replace(/\D/g, ''))} placeholder="Número" required minLength={7} autoComplete="tel" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-[#FDB931] focus:bg-white/10 transition-all" data-id="element-5842" data-mp="34ziuvgk8f522" />
                  </div>
                </div>
              </div>

              {/* SMS Consent Checkbox */}
              <div className="space-y-2" data-id="element-5843" data-mp="1piqt860o2g1m">
                <label className="flex items-start gap-3 cursor-pointer group" data-id="element-5844" data-mp="1pjjpue5wvp61">
                  <div className="relative flex-shrink-0 mt-0.5" data-id="element-5845" data-mp="3fz2t3m53th5p">
                    <input type="checkbox" checked={smsConsent} onChange={e => setSmsConsent(e.target.checked)} className="sr-only peer" data-id="element-5846" data-mp="3b0rih96zj2mf" />
                    <div className="w-5 h-5 border-2 border-gray-500 rounded bg-white/5 peer-checked:bg-[#FDB931] peer-checked:border-[#FDB931] transition-all flex items-center justify-center" data-id="element-5847" data-mp="3ozhesmlzcy9q">
                      {smsConsent && <svg className="w-3 h-3 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-5848" data-mp="2wcoa5t5gzeug">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-5849" data-mp="2s86tw3ybjjof" />
                        </svg>}
                    </div>
                  </div>
                  <span className="text-[10px] leading-tight text-gray-400 group-hover:text-gray-300 transition-colors" data-id="element-5850" data-mp="319epufdd48fc">
                    Al marcar esta casilla, acepto recibir mensajes SMS/texto
                    recurrentes de True Marketer LLC al número móvil
                    proporcionado, incluyendo actualizaciones del programa,
                    información de capacitación y mensajes de
                    marketing/promocionales, enviados mediante un sistema de
                    marcación telefónica automática/tecnología automatizada. La
                    frecuencia de los mensajes varía. Pueden aplicar tarifas de
                    mensajes y datos. Responde STOP para cancelar, HELP para
                    ayuda. El consentimiento no es una condición de compra. Ver{' '}
                    <Link to="/terms" className="text-[#FDB931] hover:text-[#FFC54D] underline" data-id="element-5851" data-mp="1btasb6geui2a">
                      Términos
                    </Link>{' '}
                    y{' '}
                    <Link to="/privacy" className="text-[#FDB931] hover:text-[#FFC54D] underline" data-id="element-5852" data-mp="12ruq3lzr1m95">
                      Política de Privacidad
                    </Link>
                    .
                  </span>
                </label>
              </div>

              {/* Submit Button */}
              <button type="submit" disabled={isSubmitting} className="w-full mt-6 bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] disabled:opacity-50 disabled:cursor-not-allowed text-black font-black uppercase tracking-wide rounded-xl py-4 shadow-lg hover:shadow-[#FDB931]/20 transition-all duration-300 transform hover:scale-[1.02]" data-id="element-5853" data-mp="33fz253lazrg6">
                {isSubmitting ? 'PROCESANDO...' : 'CONFIRMAR REGISTRO'}
              </button>

              <p className="text-center text-xs text-gray-500 mt-4" data-id="element-5854" data-mp="2fr6erviqyrx6">
                Tus datos están 100% seguros y no compartiremos tu información.
              </p>
            </form>
          </div>
        </div>}
    </div>;
}